import type { PageSwoosh } from '@constants/enums/swoosh'

export const getSwooshStyle = (
  swoosh?: PageSwoosh,
): { className?: string; backgroundImage?: string } => {
  if (!swoosh) {
    return {}
  }

  switch (swoosh) {
    default: {
      return { backgroundImage: '' }
    }
  }
}
